import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypedActivatedRoute } from '@assetaccountant/core/utils/route-utils';
import { IntegrationType } from '@assetaccountant/integrations/models/integration-type';
import { IntegrationsService } from '@assetaccountant/integrations/services/integrations.service';

import { AuthenticationService } from '../../../core/services/authentication.service';
import { XeroService } from '../../services/xero.service';

@Component({
  selector: 'app-xero-launch-tenant',
  templateUrl: './xero-launch-tenant.component.html',
  styleUrls: ['./xero-launch-tenant.component.scss'],
  standalone: false,
})
export class XeroLaunchTenantComponent implements OnInit {
  isConnecting = true;

  constructor(
    @Inject(ActivatedRoute)
    private route: TypedActivatedRoute<{}, {}, { tenantId: string; isRelog?: boolean }>,
    private authService: AuthenticationService,
    private router: Router,
    private integrationService: IntegrationsService,
    private xeroService: XeroService,
  ) {}

  get title() {
    return { pageTitle: `Xero App Launcher` };
  }

  ngOnInit() {
    this.isConnecting = true;

    const returnUrl = new URL(location.href);

    if (!returnUrl.searchParams.has('isRelog')) {
      returnUrl.searchParams.append('isRelog', 'true');
    }

    // If the user is not authenticated, we need to authenticate them with the external identity provider.
    if (!this.authService.isAuthenticated()) {
      this.authService.init(returnUrl.toString(), { acr_values: 'idp:Xero' });
      return;
    }

    // Ensure the user is authenticated with the correct identity provider.
    if (!this.route.snapshot.queryParams.isRelog) {
      this.authService.logOut(returnUrl.toString());
      return;
    }

    if (this.route.snapshot.queryParams.tenantId) {
      this.integrationService
        .listIntegrations(IntegrationType.Xero, this.route.snapshot.queryParams.tenantId)
        .subscribe(
          response => {
            const connections = response.integrations;

            if (connections.length === 0) {
              // No connections found, start the xero onboarding process.
              this.connectXero(returnUrl);
            } else if (connections.length === 1) {
              this.router.navigate([`/organisations/-/registers/${connections[0].registerId}`]);
            } else {
              this.router.navigate(['/organisations/-']);
            }
          },
          error => this.onError(),
        );
    } else {
      // No tenant id, start the xero onboarding process.
      this.connectXero(returnUrl);
    }
  }

  private connectXero(returnUrl: URL) {
    this.xeroService.beginConnect(returnUrl.toString()).subscribe({
      error: () => {
        this.onError();
      },
    });
  }

  private onError() {
    this.isConnecting = false;
  }
}
